var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sub-frame',{attrs:{"title":"公证书"}},[_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]),_c('div',{attrs:{"id":"pdfh5"}})])}
var staticRenderFns = []

export { render, staticRenderFns }